import KmSelectOption from '../km-select/select-option'
KmSelectOption.install = function (vue) {
  vue.component(KmSelectOption.name, KmSelectOption)
}
export default KmSelectOption



// WEBPACK FOOTER //
// ./src/ui/components/km-select-option/index.js